import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect, withRouter } from 'react-router-dom';
import {Menu, Popover, TreeSelect} from 'antd';
import { Auth } from '../../services/Auth';
import { logout, setSubAffiliateId, setMainAffiliateId, updateUserType } from '../../actions/LoginActions';
import { getUserAllowedAffiliates, getPermissions, setSelectedTreeValue, saveOpenTreeValue } from '../../actions/AffiliateActions';
import { getUserAllowedPartners } from '../../actions/UsersActions';
import { injectIntl } from 'react-intl'
import Languages from '../languages';
import { RoutePath } from '../../constants/SitePaths';
import AccountChangePassword from "../../routes/subAffilate/Account/ChangePassword";

/**
 * Enum for Checking user type.
 * @readonly
 * @enum {number}
 */

export const userTypeEnum = {
    /** Users in Main Affiliate site */
    MainPartner: 1,
    /** Users in SubAffiliate site */
    SubPartner: 2
}

class SiteHeader extends React.Component {
    state = {
        value: null,
        mainPartnerKey: 0,
        visible: false,
    };

    componentDidMount() {
        const { userId, userType } = this.props.user;
        const { mainPartnerId } = this.props.affiliates;

        this.props.dispatch(getUserAllowedPartners(userId));

        parseInt((userType), 10) === userTypeEnum.SubPartner && this.props.dispatch(getUserAllowedAffiliates(mainPartnerId));
    };

    componentDidUpdate(prevProps) {
        const { history } = this.props;
        const { permissions, affiliateId, allowedSubAff } = this.props.affiliates;

        if (allowedSubAff && allowedSubAff.filter(aff => aff.Key === affiliateId).length && prevProps.affiliates.affiliateId !== affiliateId) {
            permissions.includes('Reports') ? history.replace(RoutePath.REPORTS) : history.replace(RoutePath.WITHDRAW);

        }
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    };

    handleVisibleChange = visible => {
        this.setState({ visible });
    };

    onChange = value => {
        const { allowedSubAff } = this.props.affiliates;
        const { history } = this.props;

        // Check if selected affiliate is subAffiliate or mainAffiliate
        if (allowedSubAff && allowedSubAff.filter(aff => aff.Key === value).length) {

            this.props.dispatch(updateUserType(userTypeEnum.SubPartner));

            this.props.dispatch(getPermissions(value)).then((permissions) => {
                if (permissions) {
                    this.props.dispatch(setSelectedTreeValue(value))

                    // Check if selected value is subaffiliate, update subaffiliateId
                    if (allowedSubAff) {
                        Object.keys(allowedSubAff).map((key) => value === allowedSubAff[key].Key && this.props.dispatch(setSubAffiliateId(value)));
                    }
                }
            })
        } else {
            this.props.dispatch(updateUserType(userTypeEnum.MainPartner));
            this.props.dispatch(setSelectedTreeValue(value));
            this.setState({
                mainPartnerKey: value,
            }, () => {
                history.replace(RoutePath.AFFILIATES)

                // Update main partner Id
                this.props.dispatch(setMainAffiliateId(value));

                // Check if selected value is subaffiliate, update affiliateId
                if (allowedSubAff) {
                    Object.keys(allowedSubAff).map((key) => value === allowedSubAff[key].Key && this.props.dispatch(setSubAffiliateId(value)))
                }
            });
        }
    };

    // Load Data according from selected mainpartner
    onLoadData = treeNode => {
        this.setState({
            mainPartnerKey: treeNode.props.value
        });

        this.props.dispatch(saveOpenTreeValue(treeNode.props.value))
        return this.props.dispatch(getUserAllowedAffiliates(treeNode.props.value))
    };

    profileMenu = () => {

    }

    render() {
        const { allowedSubAff, treeValue } = this.props.affiliates;
        const { allowedPartners } = this.props.affUser;
        const { userType, currentUserType } = this.props.user;

        let childrenAff = allowedSubAff && Object.keys(allowedSubAff).map((key) => {
            return {
                title: allowedSubAff[key].Value,
                value: allowedSubAff[key].Key,
                key: allowedSubAff[key].Key,
                isLeaf: true,
                id: allowedSubAff[key].Key,
                pId: allowedSubAff[key].ParentId,
            }
        });

        let mainTreeData = allowedPartners && [...allowedPartners, ...allowedSubAff].map((affilate) => {
            return {
                id: affilate.PartnerId ? affilate.PartnerId : affilate.Key,
                title: affilate.PartnerName ? affilate.PartnerName : affilate.Value,
                value: affilate.PartnerId ? affilate.PartnerId : affilate.Key,
                key: affilate.PartnerId ? affilate.PartnerId : affilate.Key,
                isLeaf: affilate.PartnerId ? !affilate.IsLeaf : true,
                pId: affilate.ParentId ? affilate.ParentId : 0,
            }
        });

        if (!this.props.user.isLoggedIn && !Auth.isAuthenticated()) {
            return <Redirect to='/login' />;
        }

        const defaultVal = parseInt((userType), 10) === userTypeEnum.MainPartner ? mainTreeData && mainTreeData[0].value : childrenAff && childrenAff.length && childrenAff[0].value;

        const profileMenu = (
            <Menu>
                <Menu.Item><AccountChangePassword email={this.props.user.email} /></Menu.Item>
                <Menu.Item ><a onClick={this.props.logout}>{this.props.intl.messages.log_out}</a></Menu.Item>
            </Menu>
        )
        return (
            <header className="ta--flex ta--justify-between ta--align-center rtl--row-reverse">
                <Link to={parseInt((currentUserType), 10) === userTypeEnum.MainPartner ? "/affiliates" : "/reports"}>
                    <div className="ta--logo">{this.props.intl.messages.aff_logo}</div>
                </Link>
                <div className="ta--flex ta--align-center rtl--row-reverse">
                    <Languages></Languages>

                    <TreeSelect
                        treeDataSimpleMode
                        className='ta--mh-20'
                        style={{ width: 200 }}
                        value={treeValue || defaultVal}
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        treeData={parseInt((userType), 10) === userTypeEnum.MainPartner ? mainTreeData || [] : childrenAff}
                        onChange={this.onChange}
                        loadData={this.onLoadData}
                        treeDefaultExpandedKeys={[this.props.affiliates.openTreeValue && this.props.affiliates.openTreeValue]}
                    />

                    <Popover
                        className="my_profile_popover"
                        content={profileMenu}
                        placement="bottomRight"
                        title={this.props.user.email}
                        trigger="click"
                        visible={this.state.visible}
                        onVisibleChange={this.handleVisibleChange}
                    >
                        <i className="fi user-icon"></i>
                    </Popover>
                </div>
            </header>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        affUser: state.affUser,
        affiliates: state.affiliates
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch,
        logout: () => {
            dispatch(logout());
        }
    });
}

export default injectIntl(withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(SiteHeader)));



// WEBPACK FOOTER //
// ./src/components/header/AuthHeader.js